import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { FinancialResponsibilityIncidentService } from '../services/financial-responsibilty-incident.service';
import { FinancialResponsibilityIncidentModel } from '../models/financial-responsibility-incident.model';
import { Court } from '../models/court.model';
import { CourtService } from '../services/court.service';
import { IncidentTypeService } from '../services/incident-type.service';
import { IncidentService } from '../services/incident.service';
import { CustomerImageService } from '../../customer/shared/customer-image.service';
import { IncidentDialogContext } from '../shared/incident-dialog-context.model';
import { IncidentModalComponent } from '../incident-modal.component';
import { ConvictionIncidentService } from '../services/conviction-incident.service';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ProhibitionService } from '../../prohibition/services/prohibition.service';
import { EnumDataService } from '../services/enums.DataService';

@Component({
    templateUrl: './financial-responsibility-incident-modal.html'
})

export class FinancialResponsibilityIncidentModalComponent extends IncidentModalComponent<FinancialResponsibilityIncidentModel> {

    public vehicleJurisdictions: any[];
    public courts: Court[];

    constructor(
        public convictionService: ConvictionIncidentService,
        public dialogRef: MatDialogRef<IncidentModalComponent<FinancialResponsibilityIncidentModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<FinancialResponsibilityIncidentModel>,
        public incidentService: IncidentService,
        private courtService: CourtService,
        private service: FinancialResponsibilityIncidentService,
        location: PlatformLocation,
        fb: UntypedFormBuilder,
        typeService: IncidentTypeService,
        private customerService: CustomerImageService,
        modalService: MvdModalService,
        prohibitionService: ProhibitionService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);
        this.service = service;
        this.incidentService = incidentService;
        this.customerService = customerService;
        this.courtService = courtService;
    }

    protected onInit(form: any): void {
    }

    protected onLoadLookups(callback: (error?) => void): void {
        this.courtService.getAll().subscribe(r => this.onGetCourts(r.result, callback), callback);
    }

    private onGetCourts(result: Court[], callback: (error?) => void): void {

        this.courts = result;

        this.convictionService.getLookups().subscribe(r => {
            let lookups: any;
            lookups = r.result;

            this.vehicleJurisdictions = lookups.vehicleJurisdictions;
        }, callback);

        callback();
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: FinancialResponsibilityIncidentModel, callback: (error?) => void): void {
        this.data.incident = incident;

        this.showUserInput = true;
        callback();
    }

    protected onSaveIncident(callback: (error?: any) => void): void {

        // Get form values
        var court = this.incidentForm.get('courtId').value;
        this.data.incident.courtId = court.id;
        this.data.incident.courtCaseNumber = this.incidentForm.get('courtCaseNumber').value;

        this.data.incident.vehiclePlateNumber = this.incidentForm.get('vehiclePlateNumber').value;

        this.service.saveIncident(this.data.incident).subscribe(r => { }, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId).subscribe(result => { }, e => this.handleError, () => {
            this.dialogRef.close(true);
        });
    }
}
